"use client";
import { Space } from "antd";
import { FC } from "react";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DislikeOutlined,
  LikeOutlined,
  DislikeTwoTone,
  LikeTwoTone,
} from "@ant-design/icons";
import styles from "./index.module.css";

export type ResultType = {
  confidence: number;
  valid: boolean;
  id: number;
};

export enum Feedback {
  Dislike = -1,
  Like = 1,
}
export type ResultProps = {
  result?: ResultType;
  feedback?: Feedback;
  onFeedback?(feedback: Feedback): void;
};

const Result: FC<ResultProps> = ({ result, feedback, onFeedback }) => {
  return (
    <>
      {result && (
        <div className={styles["result-wrap"]}>
          <Space>
            {result.valid ? (
              <>
                <CheckCircleOutlined style={{ color: "green" }} />
                <span>{(result.confidence * 100).toFixed(2)}%</span>
              </>
            ) : (
              <>
                <CloseCircleOutlined style={{ color: "red" }} />
                <span>Invalid driver license</span>
              </>
            )}
            {feedback === Feedback.Like ? (
              <LikeTwoTone style={{ color: '#FF6C37' }} />
            ) : (
              <LikeOutlined onClick={() => onFeedback?.(Feedback.Like)} />
            )}
            {feedback === Feedback.Dislike ? (
              <DislikeTwoTone style={{ color: '#FF6C37' }} />
            ) : (
              <DislikeOutlined onClick={() => onFeedback?.(Feedback.Dislike)} />
            )}
          </Space>
        </div>
      )}
    </>
  );
};
export default Result;
